import "pages/Products.scss";

import {
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiIcon,
    EuiLink,
    EuiLoadingSpinner,
    EuiPage,
    EuiPageBody,
    EuiPanel,
    EuiSelect,
    EuiSpacer,
    EuiTab,
    EuiTabs,
    EuiText,
    EuiTitle,
} from "@elastic/eui";
import { useFetchLatestProductKindsQuery } from "api/react-query/queries/kinds";
import { useScreensQuery } from "api/react-query/queries/screens";
import { LatestKindsModal } from "components/LatestKindsModal";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import client from "../api/Client";
import { UserContext } from "../App";
import { ProductResults } from "../components/ProductResults";
import API_URL from "../Constants";
import { ShopContext } from "../utils/Shop";
import { capitalizeFirstLetter } from "../utils/Utils";

const tabs = [
    {
        id: "cannabis",
        name: "Cannabis",
        href: "/products/cannabis",
        disabled: false,
    },
    {
        id: "horeca",
        name: "Horeca",
        href: "/products/horeca",
        disabled: false,
    },
];

export function Products(props) {
    // Get shop context
    const { shopId, isUsingMultiScreen } = useContext(ShopContext);
    const [filteredData, setFilteredData] = useState([]);
    const [filteredScreenData, setFilteredScreenData] = useState([]);
    const [cannabisData, setCannabisData] = useState(undefined);
    const [horecaData, setHorecaData] = useState(undefined);
    const [selectedTabId, setSelectedTabId] = useState(props.showCannabis ? "cannabis" : "horeca");
    const [selectScreenOptions, setSelectScreenOptions] = useState();
    const [selectedScreenId, setSelectedScreenId] = useState("-1");
    const [searchIsOpen, setSearchIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const user = useContext(UserContext);
    const { screenOptions, isLoading } = useScreensQuery();
    const [shopGroupId, setShopGroupId] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);

    const closeModal = () => setIsModalVisible(false);
    const showModal = () => setIsModalVisible(true);

    const {
        data: latestKinds,
        isLoading: latestKindsLoading,
        isError: latestKindsIsError,
    } = useFetchLatestProductKindsQuery(shopGroupId);

    function filterData(prices, selectedTab) {
        // Prepare the data for horeca and cannabis product results
        if (selectedTab === "cannabis") {
            return prices
                .filter((price) => price.kind_name)
                .map((price) => {
                    price.name = price.kind_name;
                    if (price.json_prices) {
                        price.prices = {};
                        for (let i = 0; i < price.json_prices.length; i++) {
                            price.prices[price.json_prices[i].label.replace(" ", "").replace("gram", "g")] =
                                price.json_prices[i].price;
                        }
                    } else {
                        price.prices = {
                            half: price.half,
                            one: price.one,
                            two_five: price.two_five,
                            five: price.five,
                            joint: price.joint,
                            piece: price.piece,
                        };
                    }
                    if (price.strains.length > 0) {
                        price.description = price.strains.map((strain) => strain.name).join(" - ");
                    } else {
                        price.description = price.kind_short_description_nl;
                    }
                    return price;
                });
        } else if (selectedTab === "horeca") {
            return prices
                .filter((price) => price.product_name)
                .map((price) => {
                    price.name = price.product_name;
                    price.prices = {
                        half: price.half,
                        one: price.one,
                        two_five: price.two_five,
                        five: price.five,
                        joint: price.joint,
                        piece: price.piece,
                    };
                    price.description = price.product_short_description_nl;
                    return price;
                });
        }
    }

    const refreshData = (tabName) => {
        // Make data reload easy
        let isHoreca = tabName === "horeca";

        client.get(`${API_URL}/v1/shops/${shopId}?is_horeca=${isHoreca}`).then((result) => {
            if (selectedTabId === tabName) {
                const filteredData = filterData(result.data.prices, selectedTabId);
                setFilteredData(filteredData);
                setFilteredScreenData(filteredData);
                setShopGroupId(result.data.shop_group_id);
            }

            if (isHoreca) {
                setHorecaData(result.data.prices);
            } else {
                setCannabisData(result.data.prices);
            }
        });
    };

    useEffect(() => {
        refreshData("horeca");
        refreshData("cannabis");
        // Todo: fix this for real ->
        // eslint-disable-next-line
    }, []);

    // const getKindDisplayOptions = () => {
    //     if (kindsIsLoading) {
    //         return [
    //             {
    //                 value: "latest",
    //                 label: "Loading...",
    //                 isDisabled: true,
    //             },
    //         ];
    //     }

    //     if (kindsIsError) {
    //         return [
    //             {
    //                 value: "latest",
    //                 label: "Error loading kinds",
    //                 isDisabled: true,
    //             },
    //         ];
    //     }

    //     return kindsOptions ?? [];
    // };

    // const displayOptions = getKindDisplayOptions();

    useEffect(() => {
        if (!isLoading && isUsingMultiScreen) {
            const options = screenOptions.map((so) => {
                return {
                    value: so.id,
                    text: so.name,
                };
            });
            setSelectScreenOptions([
                {
                    value: "-1",
                    text: "Alle schermen",
                },
                ...options,
            ]);
        }
    }, [screenOptions, isLoading, isUsingMultiScreen, setSelectScreenOptions]);

    useEffect(() => {
        console.log("Set screen");
        setFilteredScreenData(
            selectedScreenId === "-1"
                ? filteredData
                : filteredData.filter((price) => {
                      if (selectedScreenId === "-1") {
                          return true;
                      } else {
                          if (
                              price.category_screens &&
                              price.category_screens.find((cs) => cs.screen_id === selectedScreenId)
                          ) {
                              return true;
                          }
                      }
                      return false;
                  })
        );
    }, [selectedScreenId, filteredData]);

    useEffect(() => {
        if (cannabisData && horecaData) {
            setLoading(false);
        }
    }, [cannabisData, horecaData]);

    const setSelectedTab = (id) => {
        let filteredData = id === "cannabis" ? filterData(cannabisData, id) : filterData(horecaData, id);

        setSelectedTabId(id);
        setFilteredData(filteredData);
    };

    const renderTabs = () => {
        return tabs.map((tab, index) => (
            <Link to={tab.href} key={index}>
                <EuiTab onClick={() => setSelectedTab(tab.id)} isSelected={tab.id === selectedTabId} key={index}>
                    {tab.name}
                </EuiTab>
            </Link>
        ));
    };
    const showAdminLinks = user.profile.is_superuser;

    return (
        <EuiPage>
            <EuiPageBody component="div">
                <EuiPanel color="transparent" hasBorder={false} hasShadow={false}>
                    <EuiTabs>{renderTabs()}</EuiTabs>
                    <EuiSpacer />
                    <EuiFlexGroup className="responsiveFlexGroup" alignItems="center" justifyContent="spaceBetween">
                        <EuiFlexItem>
                            <EuiTitle size="l">
                                <h1>{capitalizeFirstLetter(selectedTabId)} Producten</h1>
                            </EuiTitle>
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <EuiFlexGroup className="responsiveButtonGroup">
                                {isUsingMultiScreen && selectScreenOptions && (
                                    <EuiFlexItem>
                                        <EuiSelect
                                            options={selectScreenOptions}
                                            onChange={(e) => setSelectedScreenId(e.target.value ?? null)}
                                        />
                                    </EuiFlexItem>
                                )}
                                {selectedTabId === "cannabis" && (
                                    <EuiFlexItem grow={false}>
                                        <div>
                                            <EuiButton size="s" onClick={showModal}>
                                                Latest Products
                                            </EuiButton>
                                        </div>
                                    </EuiFlexItem>
                                )}
                                {isModalVisible && (
                                    <LatestKindsModal
                                        closeModal={closeModal}
                                        items={latestKinds}
                                        isLoading={latestKindsLoading}
                                        isError={latestKindsIsError}
                                    />
                                )}
                                <EuiFlexItem grow={false}>
                                    <EuiLink href={`new-product/${selectedTabId}`}>
                                        <EuiButton size="s" iconType="plus">
                                            Prijs
                                        </EuiButton>
                                    </EuiLink>
                                </EuiFlexItem>
                                <EuiFlexItem grow={false}>
                                    <EuiLink href={`/prices`}>
                                        <EuiButton size="s" iconType="pencil">
                                            Prijs Combi
                                        </EuiButton>
                                    </EuiLink>
                                </EuiFlexItem>
                                {selectedTabId === "cannabis" && (
                                    <>
                                        {shopId !== "f155b35a-14a1-4866-867f-93fe21e9769b" && (
                                            <EuiFlexItem grow={false}>
                                                <EuiLink href={"new-product/kind"}>
                                                    <EuiButton size="s" iconType="plus">
                                                        Wiet
                                                    </EuiButton>
                                                </EuiLink>
                                            </EuiFlexItem>
                                        )}

                                        {showAdminLinks && (
                                            <>
                                                <EuiFlexItem grow={false}>
                                                    <EuiLink href={"manage/strains-tags"}>
                                                        <EuiButton size="s" iconType="pencil">
                                                            Kruisingen & Tags
                                                        </EuiButton>
                                                    </EuiLink>
                                                </EuiFlexItem>
                                            </>
                                        )}
                                    </>
                                )}
                                <EuiFlexItem grow={false}>
                                    <EuiLink onClick={() => setSearchIsOpen(!searchIsOpen)}>
                                        <EuiIcon type="search" size="l" />
                                    </EuiLink>
                                </EuiFlexItem>
                            </EuiFlexGroup>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                    <EuiSpacer size="s" />
                    <div>
                        {loading ? (
                            <EuiLoadingSpinner size="xl" />
                        ) : (
                            <>
                                {filteredData.length > 0 ? (
                                    <ProductResults
                                        products={filteredScreenData}
                                        searchIsOpen={searchIsOpen}
                                        mode={selectedTabId}
                                        key={selectedTabId} // Needed so tab re-renders
                                        refresh={refreshData}
                                    />
                                ) : (
                                    <EuiText>Er zijn geen producten van dit type.</EuiText>
                                )}
                            </>
                        )}
                    </div>
                </EuiPanel>
            </EuiPageBody>
        </EuiPage>
    );
}

export default Products;
